import { render, staticRenderFns } from "./OrderShipmentDetails.vue?vue&type=template&id=3fe31c88&"
import script from "./OrderShipmentDetails.vue?vue&type=script&lang=ts&"
export * from "./OrderShipmentDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports